/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBarberShiftsBookedQueryResponse, GetApiBarberShiftsBookedQueryParams, GetApiBarberShiftsBooked400, GetApiBarberShiftsBooked401, GetApiBarberShiftsBooked403, GetApiBarberShiftsBooked404, GetApiBarberShiftsBooked500 } from "../entities/GetApiBarberShiftsBooked";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiBarberShiftsBooked } from "../api/getApiBarberShiftsBooked";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiBarberShiftsBookedQueryKey = (params: GetApiBarberShiftsBookedQueryParams) => [{ url: '/api/barber/shifts/booked' }, ...(params ? [params] : [])] as const

export type GetApiBarberShiftsBookedQueryKey = ReturnType<typeof getApiBarberShiftsBookedQueryKey>

export function getApiBarberShiftsBookedQueryOptions(params: GetApiBarberShiftsBookedQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiBarberShiftsBookedQueryKey(params)
        return queryOptions<GetApiBarberShiftsBookedQueryResponse, ResponseErrorConfig<GetApiBarberShiftsBooked400 | GetApiBarberShiftsBooked401 | GetApiBarberShiftsBooked403 | GetApiBarberShiftsBooked404 | GetApiBarberShiftsBooked500>, GetApiBarberShiftsBookedQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiBarberShiftsBooked(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Получить список незавершенных забронированных смен текущего мастера за период
 * @summary Забронированные смены
 * {@link /api/barber/shifts/booked}
 */
export function useGetApiBarberShiftsBooked<TData = GetApiBarberShiftsBookedQueryResponse, TQueryData = GetApiBarberShiftsBookedQueryResponse, TQueryKey extends QueryKey = GetApiBarberShiftsBookedQueryKey>(params: GetApiBarberShiftsBookedQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetApiBarberShiftsBookedQueryResponse, ResponseErrorConfig<GetApiBarberShiftsBooked400 | GetApiBarberShiftsBooked401 | GetApiBarberShiftsBooked403 | GetApiBarberShiftsBooked404 | GetApiBarberShiftsBooked500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiBarberShiftsBookedQueryKey(params)
         

         const query = useQuery({
          ...getApiBarberShiftsBookedQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetApiBarberShiftsBooked400 | GetApiBarberShiftsBooked401 | GetApiBarberShiftsBooked403 | GetApiBarberShiftsBooked404 | GetApiBarberShiftsBooked500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}